import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import ReduxToastr from 'react-redux-toastr';

import store from './store/store';
import AppRoutes from "./router/AppRoutes";
import HeadParams from '../client/js/component/common/HeadParams';
import { AuthProvider } from "./providers/AuthContext";
import { MobileProvider } from "./providers/MobileContext";

const App = () => {
    return (
        <Provider store={store}>
            <AuthProvider>
                <MobileProvider>
                    <div>
                        <HeadParams/>
                        <BrowserRouter>
                            <AppRoutes />
                        </BrowserRouter>
                        <ReduxToastr
                            timeOut={5000}
                            newestOnTop={false}
                            preventDuplicates
                            position="top-right"
                            transitionIn="fadeIn"
                            transitionOut="fadeOut"
                        />
                    </div>
                </MobileProvider>
            </AuthProvider>
        </Provider>
    )
}

export default App;
